import React from 'react'
import "./health.scss"
import MedicalBillsList from './sections/medicalBillsList'
import PerformBetter from './sections/performBetter'
import YourHealthyHospital from './sections/yourHealthyHospital'
import Letsgo from "../connectors/letsgo"

function Health() {
  return (
    <div className='
    container-health'>
      <div className="section-your-healthy-hospital">
        <YourHealthyHospital />
      </div>
      <div className="section-perform-better">
        <PerformBetter />
      </div>
      <div className="section-medical-bills-list">
        <MedicalBillsList />
      </div>
      <div className="section-lets-go">
        <Letsgo />
      </div>
    </div>
  )
}

export default Health